import { Book } from "./Book";
import { Review } from "./Review";

export enum CardType {
	ReadNow = "read_now",
	AlreadyRead = "already_read",
	WantRead = "want_read"
}

export enum CardPropertyType {
	DateBegin = "date_begin",
	DateFinish = "date_finish",
	CardHistoryStart = 'card_history_start',
	CardHistoryEnd = 'card_history_end',
	Pages = "pages",
	Notes = "notes",
	Type = "type"
}

export interface CardProperties {
	[name: string]: string;
}

export interface CardHistory {
	id: number;
	startDate: Date;
	finishDate: Date;
}

export enum CardColor {
	Blue = 'blue',
	Orange = 'orange',
	White = 'white',
	Gray = 'gray',
	Purple = 'purple',
	Green = 'green',
	Red = 'red'
}

export interface LibraryCard {
	iId?: number;
	eId?: number;
	cardType: CardType;
	book: Book;
	color?: CardColor;
	properties?: CardProperties;
	history?: CardHistory[];
	review?: Review;
}
